var cov_xov6bf1v7 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/Field.tsx",
      hash = "152198cdabdfa8e163cacddcee70dcfe24aa1dc5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/Field.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 16
        }
      },
      "1": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 52
        }
      },
      "2": {
        start: {
          line: 19,
          column: 20
        },
        end: {
          line: 19,
          column: 66
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 56
        }
      },
      "4": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "5": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 32
        }
      },
      "6": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 30
        }
      },
      "7": {
        start: {
          line: 33,
          column: 49
        },
        end: {
          line: 33,
          column: 59
        }
      },
      "8": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "9": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 78
        }
      },
      "10": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 45,
          column: 5
        }
      },
      "11": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 44,
          column: 8
        }
      },
      "12": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 86
        }
      },
      "13": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 15
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 40
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 54
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 23,
            column: 27
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 23
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 11
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 32
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 20
          },
          end: {
            line: 19,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 19,
            column: 39
          },
          end: {
            line: 19,
            column: 61
          }
        }, {
          start: {
            line: 19,
            column: 64
          },
          end: {
            line: 19,
            column: 66
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 24,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 24,
            column: 13
          }
        }, {
          start: {
            line: 24,
            column: 17
          },
          end: {
            line: 24,
            column: 34
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }],
        line: 35
      },
      "4": {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }],
        line: 38
      },
      "5": {
        loc: {
          start: {
            line: 43,
            column: 18
          },
          end: {
            line: 43,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 18
          },
          end: {
            line: 43,
            column: 26
          }
        }, {
          start: {
            line: 43,
            column: 31
          },
          end: {
            line: 43,
            column: 45
          }
        }, {
          start: {
            line: 43,
            column: 49
          },
          end: {
            line: 43,
            column: 72
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import * as React from 'react';
import shallowEqual from '../utils/shallowEqual';

var Field =
/*#__PURE__*/
function (_ref) {
  _inherits(Field, _ref);

  var _super = _createSuper2(Field);

  function Field(props) {
    var _this;

    _classCallCheck(this, Field);

    cov_xov6bf1v7.f[0]++;
    cov_xov6bf1v7.s[0]++;
    _this = _super.call(this, props);
    cov_xov6bf1v7.s[1]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this)); // this.cacheChildren = undefined
    // this.cacheElement = null

    return _this;
  }

  _createClass(Field, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      cov_xov6bf1v7.f[1]++;
      var options = (cov_xov6bf1v7.s[2]++, this.props.cache ? (cov_xov6bf1v7.b[0][0]++, {
        skip: ['children']
      }) : (cov_xov6bf1v7.b[0][1]++, {}));
      cov_xov6bf1v7.s[3]++;
      return !shallowEqual(this.props, nextProps, options);
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      cov_xov6bf1v7.f[2]++;
      cov_xov6bf1v7.s[4]++;

      if ((cov_xov6bf1v7.b[2][0]++, value) && (cov_xov6bf1v7.b[2][1]++, value.nativeEvent)) {
        cov_xov6bf1v7.b[1][0]++;
        cov_xov6bf1v7.s[5]++;
        // eslint-disable-next-line
        value = value.target.value;
      } else {
        cov_xov6bf1v7.b[1][1]++;
      }

      cov_xov6bf1v7.s[6]++;
      this.props.onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      cov_xov6bf1v7.f[3]++;

      var _ref2 = (cov_xov6bf1v7.s[7]++, this.props),
          children = _ref2.children,
          value = _ref2.value,
          error = _ref2.error,
          disabled = _ref2.disabled;

      cov_xov6bf1v7.s[8]++;

      if (typeof children === 'function') {
        cov_xov6bf1v7.b[3][0]++;
        cov_xov6bf1v7.s[9]++;
        return children({
          value: value,
          error: error,
          onChange: this.handleChange,
          disabled: disabled
        });
      } else {
        cov_xov6bf1v7.b[3][1]++;
      }

      cov_xov6bf1v7.s[10]++;

      if (
      /*#__PURE__*/
      React.isValidElement(children)) {
        cov_xov6bf1v7.b[4][0]++;
        cov_xov6bf1v7.s[11]++;
        return (
          /*#__PURE__*/
          React.cloneElement(children, {
            value: value,
            error: error,
            onChange: this.handleChange,
            disabled: (cov_xov6bf1v7.b[5][0]++, disabled) || (cov_xov6bf1v7.b[5][1]++, children.props) && (cov_xov6bf1v7.b[5][2]++, children.props.disabled)
          })
        );
      } else {
        cov_xov6bf1v7.b[4][1]++;
      }

      cov_xov6bf1v7.s[12]++;
      console.error(new Error('Form.Field expect a single ReactElement or a function.'));
      cov_xov6bf1v7.s[13]++;
      return null;
    }
  }]);

  return Field;
}((React.Component));

Field.defaultProps = {
  cache: false
};
export default Field;